export default "__VITE_ASSET__BQeMpaUR__"